import { useEffect, useState } from "react";
import axiosInstance from "../../../../services/AxiosInstance";
import LoadingIcon from "../../Icon/LoadingIcon";

// Extrai até 2 iniciais do nome completo. Ex: "João Cleber" → "JC"
function getInitials(name) {
    if (!name) return "?";
    return name
        .trim()
        .split(/\s+/)
        .map(n => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
}

const ImageDownload = (props) => {

    const { id, path, circle, style, name } = props;
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    // imgError: true quando o <img> dispara onError (base64 inválido ou corrompido)
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        setImageUrl(null);
        setImgError(false);

        if (!id) return;

        setLoading(true);
        axiosInstance.get(path + "/download/base64/" + id)
            .then(resp => {
                // Backend retorna 204 (sem foto) com body vazio.
                // Só seta imageUrl se vier base64 real para evitar <img> invisível.
                if (resp.data) {
                    setImageUrl("data:image/jpeg;base64," + resp.data);
                }
            })
            .catch(() => {
                // 404 = sem foto cadastrada. Avatar com iniciais assume o lugar.
            })
            .finally(() => setLoading(false));
    }, [id, path]);

    if (loading) {
        return <div className="me-2"><LoadingIcon className="fa-2x" /></div>;
    }

    // Dimensões: respeita o style externo, mas garante valores mínimos
    const w = style?.width ?? 48;
    const h = style?.height ?? w;
    const borderRadius = circle ? "50%" : "8px";

    // Mostra a foto se carregou e não deu erro de renderização
    if (imageUrl && !imgError) {
        return (
            <img
                src={imageUrl}
                alt={name || ""}
                // Segue o mesmo padrão visual da agenda (collab-avatar)
                style={{
                    width: w,
                    height: h,
                    borderRadius,
                    objectFit: "cover",
                    objectPosition: "center top",
                    border: "1px solid rgba(142, 176, 195, 0.68)",
                    background: "linear-gradient(180deg, #f8fbfd 0%, #e7eff4 100%)",
                    boxShadow: "0 12px 22px rgba(35, 74, 92, 0.12)",
                    flexShrink: 0,
                }}
                // Rede de segurança: se o base64 for inválido o navegador dispara onError
                onError={() => setImgError(true)}
            />
        );
    }

    // Fallback: avatar com iniciais seguindo o padrão visual da agenda (collab-avatar-initials)
    const fontSize = typeof w === "number" ? Math.round(w * 0.34) : "0.92rem";

    return (
        <div
            title={name || ""}
            style={{
                width: w,
                height: h,
                borderRadius,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #ff8b2b 0%, #ffb066 100%)",
                color: "#fff",
                fontWeight: 700,
                fontSize,
                letterSpacing: "0.04em",
                flexShrink: 0,
                userSelect: "none",
                border: "1px solid rgba(142, 176, 195, 0.68)",
                boxShadow: "0 12px 22px rgba(35, 74, 92, 0.12)",
            }}
        >
            {getInitials(name)}
        </div>
    );
};

export default ImageDownload;
